'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = configureElementConnectionsStore;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _redux = require('redux');

var _reduxLogger = require('redux-logger');

var _getClientConfig = require('../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _reduxBulkingMiddleware = require('../../store/reduxBulkingMiddleware');

var _rootElementConnectionsReducer = require('./reducers/rootElementConnectionsReducer');

var _rootElementConnectionsReducer2 = _interopRequireDefault(_rootElementConnectionsReducer);

var _configConstants = require('../../../../config/configConstants');

var _connectionsConstants = require('./connectionsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants


// Middleware
// Lib
function configureElementConnectionsStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();

    var middlewareList = [];
    var config = (0, _getClientConfig2.default)();

    middlewareList.push((0, _reduxBulkingMiddleware.bulkingMiddleware)({ bulkActionTypes: _connectionsConstants.BULK_CONNECTIONS_ACTIONS }));

    if (config.debugLevel > _configConstants.DEBUG_LEVEL.OFF) {
        middlewareList.push((0, _reduxLogger.createLogger)({
            collapsed: true,
            duration: true,
            colors: {
                title: function title(action) {
                    return 'teal';
                }
            }
        }));
    }

    var middleware = _redux.applyMiddleware.apply(null, middlewareList);

    return (0, _redux.createStore)((0, _reduxBulkingMiddleware.enableReducerBatching)(_rootElementConnectionsReducer2.default), initialState, middleware);
}

// Reducer


// Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/configureElementConnectionsStore.js
// module id = 1708
// module chunks = 0